(function(){
  function ltInit(){
    var P = window.defined_product_json;
    if(!P){setTimeout(ltInit,200);return;}
    function fv(s){ for(var i=0;i<P.variants.length;i++) if(P.variants[i].title.indexOf(s)!==-1) return P.variants[i]; return null; }

  // ============ Data ============
  var BUNDLES=[
    {
      id:'essentials',
      name:'The Essentials',
      sub:'Wallet + matching keychain',
      priceOriginal:75.00,
      priceFinal:67.50,
      discount:7.50,
      itemsLabel:'2 items',
      hasPhone:false,
      vk:'Essentials'
    },
    {
      id:'full-set',
      name:'The Full Set',
      sub:'Wallet + keychain + luggage tag + phone case',
      priceOriginal:109.00,
      priceFinal:98.10,
      discount:10.90,
      itemsLabel:'4 items',
      hasPhone:true,
      vk:'Full Set'
    }
  ];

  var WALLET_TYPES=[
    {id:'bifold',  name:'Bifold',  sub:'Card slots + bill pocket'},
    {id:'trifold', name:'Trifold', sub:'Card slots + bill pocket + ID window'}
  ];

  var LC=[
    {i:'arizona',n:'Arizona',h:'#b07a56'},
    {i:'sicilian-brown',n:'Sicilian Brown',h:'#6b5040'},
    {i:'black',n:'Black',h:'#2a2a2a'},
    {i:'dark-espresso',n:'Dark Espresso',h:'#3e3028'},
    {i:'caramel',n:'Caramel',h:'#c08a64'},
    {i:'blueberry',n:'Blueberry',h:'#2e3548'},
    {i:'forest-green',n:'Forest Green',h:'#3a5a3a'},
    {i:'indian-summer',n:'Indian Summer',h:'#d4a04a'},
    {i:'gray-sand',n:'Gray Sand',h:'#d4ccc0'},
    {i:'country-grey',n:'Country Grey',h:'#7a7a72'},
    {i:'sangria',n:'Sangria',h:'#5a2030'}
  ];

  var MG=[
    {i:'straight-font',    n:'Straight Font',     s:'Classic block caps \u2014 any length',              is3:false},
    {i:'block-monogram',   n:'Block Monogram',    s:'3 letters, serif caps',                             is3:true},
    {i:'centered-monogram',n:'Centered Monogram', s:'3 letters, middle initial enlarged',                is3:true},
    {i:'circle-monogram',  n:'Circle Monogram',   s:'3 letters in a round frame',                        is3:true}
  ];
  var DEFAULT_MONO='straight-font';

  var EM='leatherius.woodman@gmail.com';

  function fc(id){for(var i=0;i<LC.length;i++)if(LC[i].i===id)return LC[i];return LC[0];}
  function fm(id){for(var i=0;i<MG.length;i++)if(MG[i].i===id)return MG[i];return MG[0];}
  function fb(id){for(var i=0;i<BUNDLES.length;i++)if(BUNDLES[i].id===id)return BUNDLES[i];return BUNDLES[0];}
  function esc(s){return s?s.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'):''}
  function imgUrl(type,id){var A=window.LT_ASSETS;return (A&&A[type]&&A[type][id])?A[type][id]:'';}

  var S={
    bundle:'full-set',
    wallet:'bifold',
    name:'',
    gold:false,
    mono:DEFAULT_MONO,
    color:'arizona',
    phone:'',
    deadline:''
  };

  var root=document.getElementById('lt-configurator');
  if(!root) return;

  // ============ Full render ============
  function R(){
    var b=fb(S.bundle);
    var h='';
    h+='<h1 class="lt-hd-title">'+esc(P.title)+'</h1>';
    h+='<p class="lt-hd-craft">Every piece handmade in our studio \u2014 wallet, keychain, tag, case. Any phone model, any initials, any color.</p>';
    h+='<p class="lt-hd-free">Free shipping on all orders</p>';

    // Bundle picker
    h+='<div class="lt-lbl-row"><label class="lt-lbl">Choose your set <span class="lt-req">*</span></label></div>';
    h+='<div class="lt-bundles">';
    for(var i=0;i<BUNDLES.length;i++){
      var bn=BUNDLES[i],active=S.bundle===bn.id;
      h+='<button type="button" class="lt-bun'+(active?' on':'')+'" data-bun="'+bn.id+'">';
      h+='<span class="lt-bun-rd"><span class="lt-bun-dt"></span></span>';
      h+='<div class="lt-bun-nfo"><div class="lt-bun-ttl"><span class="lt-bun-nm">'+bn.name+'</span>';
      h+='</div><span class="lt-bun-sub">'+bn.sub+'</span></div>';
      h+='<div class="lt-bun-pr"><span class="lt-bun-pr-o">$'+bn.priceOriginal.toFixed(2)+'</span><span class="lt-bun-pr-n">$'+bn.priceFinal.toFixed(2)+'</span></div>';
      h+='</button>';
    }
    h+='</div>';

    // Wallet style
    h+='<div class="lt-lbl-row"><label class="lt-lbl">Wallet style</label></div>';
    h+='<div class="lt-wt">';
    for(var j=0;j<WALLET_TYPES.length;j++){
      var wt=WALLET_TYPES[j],wa=S.wallet===wt.id;
      h+='<button type="button" class="lt-wt-o'+(wa?' on':'')+'" data-wt="'+wt.id+'"><span class="lt-wt-t">'+wt.name+'</span><span class="lt-wt-s">'+wt.sub+'</span></button>';
    }
    h+='</div>';

    // Personalization
    h+='<div class="lt-lbl-row"><label class="lt-lbl">Personalization <span class="lt-req">*</span></label></div>';
    h+='<div class="lt-card">';
    h+='<div class="lt-r1">';
    h+='<input class="lt-name" type="text" id="lt-nm" value="'+esc(S.name)+'" placeholder="e.g. ALEXANDER">';
    h+='<button type="button" class="lt-gt '+(S.gold?'lt-gt-on':'lt-gt-off')+'" id="lt-gt"><div class="lt-gt-k"></div><span class="lt-gt-l">'+(S.gold?'Gold Stamp \u2726':'Plain Stamp')+'</span></button>';
    h+='</div>';

    // Monogram style
    h+='<div class="lt-mp"><span class="lt-mp-lbl">Style</span><div class="lt-mts">';
    for(var k=0;k<MG.length;k++){
      var ms=MG[k],ma=S.mono===ms.i,murl=imgUrl('monogram',ms.i);
      h+='<button type="button" class="lt-mt'+(ma?' on':'')+'" data-mg="'+ms.i+'" title="'+ms.n+'"'+(murl?' style="background-image:url('+murl+')"':'')+'></button>';
    }
    h+='</div></div>';
    h+='<div class="lt-mp-nm" id="lt-mp-nm">'+renderMonoName(S.mono)+'</div>';

    // Leather
    h+='<div class="lt-cs"><span class="lt-cs-lbl">Leather</span><div class="lt-sw">';
    for(var m=0;m<LC.length;m++){
      var c=LC[m],ca=S.color===c.i,lurl=imgUrl('leather',c.i);
      var style='background-color:'+c.h+(lurl?';background-image:url('+lurl+')':'');
      h+='<button type="button" class="lt-s'+(ca?' on':'')+'" style="'+style+'" data-cl="'+c.i+'" title="'+c.n+'"></button>';
    }
    h+='</div><span class="lt-cn" id="lt-cn">'+fc(S.color).n+'</span></div>';
    h+='</div>'; // end card

    // Phone (conditional)
    h+='<div class="lt-phone'+(b.hasPhone?' show':'')+'" id="lt-phone">';
    h+='<div class="lt-lbl-row" style="margin-top:18px"><label class="lt-lbl">iPhone / Samsung Model <span class="lt-req">*</span></label></div>';
    h+='<input class="lt-tx" type="text" id="lt-ph" value="'+esc(S.phone)+'" placeholder="e.g. iPhone 15 Pro">';
    h+='</div>';

    // Deadline
    h+='<div class="lt-lbl-row" style="margin-top:18px"><label class="lt-lbl">Gift Deadline <span class="lt-o">(optional) \u2014 we</span> <span class="lt-rush">RUSH</span> <span class="lt-o">if possible</span></label></div>';
    h+='<input class="lt-dl" type="text" id="lt-dl" value="'+esc(S.deadline)+'" placeholder="We average a 2-week turnaround. Tell us your event date if it\u2019s sooner.">';

    // Summary
    h+='<div class="lt-sum">';
    h+='<div class="lt-sr"><span class="lt-sr-l">'+b.name+' \u00b7 '+b.itemsLabel+'</span><span class="lt-sr-l lt-strike">$'+b.priceOriginal.toFixed(2)+'</span></div>';
    h+='<div class="lt-sr"><span class="lt-red">Site-wide 10% off</span><span class="lt-red">\u2212$'+b.discount.toFixed(2)+'</span></div>';
    h+='<div class="lt-sr"><span class="lt-green">Gift wrap + Shipping</span><span class="lt-green">FREE</span></div>';
    h+='<div class="lt-tot"><span class="lt-tot-l">Total</span><span class="lt-tot-p">$'+b.priceFinal.toFixed(2)+'</span></div>';
    h+='<button type="button" class="lt-atc" id="lt-ac">Add to Cart</button>';
    h+='</div>';

    // Contact
    h+='<div class="lt-ct"><p class="lt-ct-t"><strong>Have questions?</strong> Want to see a mockup of your design before ordering?</p><div class="lt-ct-bs"><button type="button" class="lt-ct-b" id="lt-chat">\ud83d\udcac Live Chat</button><button type="button" class="lt-ct-b" id="lt-eml">\u2709\ufe0f Copy Email</button></div><p class="lt-ct-n">Real humans here \u2014 sometimes we reply instantly, sometimes it takes a bit. Small business life!</p></div>';

    root.innerHTML=h;
    bind();
  }

  function renderMonoName(id){
    var m=fm(id);
    var html='<strong>'+m.n+'</strong> \u2014 '+m.s;
    if(m.is3) html+='<em>Type the initials in the order you want them stamped.</em>';
    return html;
  }

  // ============ Targeted DOM updates ============
  function updateBundle(){
    var b=fb(S.bundle);
    root.querySelectorAll('.lt-bun').forEach(function(el){
      el.classList.toggle('on', el.getAttribute('data-bun')===S.bundle);
    });
    // Phone field show/hide
    var phone=root.querySelector('#lt-phone');
    if(phone) phone.classList.toggle('show', b.hasPhone);
    // Summary
    var rows=root.querySelectorAll('.lt-sum .lt-sr');
    if(rows.length>=2){
      rows[0].children[0].textContent=b.name+' \u00b7 '+b.itemsLabel;
      rows[0].children[1].textContent='$'+b.priceOriginal.toFixed(2);
      rows[1].children[1].textContent='\u2212$'+b.discount.toFixed(2);
    }
    var totP=root.querySelector('.lt-tot-p');
    if(totP) totP.textContent='$'+b.priceFinal.toFixed(2);
  }

  function updateWallet(){
    root.querySelectorAll('.lt-wt-o').forEach(function(el){
      el.classList.toggle('on', el.getAttribute('data-wt')===S.wallet);
    });
  }

  function updateGold(){
    var gt=root.querySelector('#lt-gt');
    if(!gt) return;
    gt.className='lt-gt '+(S.gold?'lt-gt-on':'lt-gt-off');
    var lbl=gt.querySelector('.lt-gt-l');
    if(lbl) lbl.textContent=S.gold?'Gold Stamp \u2726':'Plain Stamp';
  }

  function updateMono(){
    root.querySelectorAll('.lt-mt').forEach(function(el){
      el.classList.toggle('on', el.getAttribute('data-mg')===S.mono);
    });
    var nm=root.querySelector('#lt-mp-nm');
    if(nm) nm.innerHTML=renderMonoName(S.mono);
  }

  function updateColor(){
    root.querySelectorAll('.lt-s').forEach(function(el){
      el.classList.toggle('on', el.getAttribute('data-cl')===S.color);
    });
    var cn=root.querySelector('#lt-cn');
    if(cn) cn.textContent=fc(S.color).n;
  }

  // ============ Event binding ============
  function bind(){
    // Bundles
    root.querySelectorAll('.lt-bun').forEach(function(el){
      el.addEventListener('click',function(){S.bundle=this.getAttribute('data-bun');updateBundle();});
    });

    // Wallet type
    root.querySelectorAll('.lt-wt-o').forEach(function(el){
      el.addEventListener('click',function(){S.wallet=this.getAttribute('data-wt');updateWallet();});
    });

    // Name input
    var nm=root.querySelector('#lt-nm');
    if(nm) nm.addEventListener('input',function(){S.name=this.value;});

    // Gold toggle
    var gt=root.querySelector('#lt-gt');
    if(gt) gt.addEventListener('click',function(){S.gold=!S.gold;updateGold();});

    // Monogram
    root.querySelectorAll('.lt-mt').forEach(function(el){
      el.addEventListener('click',function(){S.mono=this.getAttribute('data-mg');updateMono();});
    });

    // Leather
    root.querySelectorAll('.lt-s').forEach(function(el){
      el.addEventListener('click',function(){S.color=this.getAttribute('data-cl');updateColor();});
    });

    // Phone
    var ph=root.querySelector('#lt-ph');
    if(ph) ph.addEventListener('input',function(){S.phone=this.value;});

    // Deadline
    var dl=root.querySelector('#lt-dl');
    if(dl) dl.addEventListener('input',function(){S.deadline=this.value;});

    // ATC
    var ac=root.querySelector('#lt-ac');
    if(ac) ac.addEventListener('click',addToCart);

    // Contact
    var ce=root.querySelector('#lt-eml');
    if(ce) ce.addEventListener('click',function(){
      navigator.clipboard.writeText(EM).then(function(){
        ce.textContent='\u2713 Copied!';
        setTimeout(function(){ce.textContent='\u2709\ufe0f Copy Email';},2000);
      });
    });
    var ch=root.querySelector('#lt-chat');
    if(ch) ch.addEventListener('click',function(){
      if(window.Tidio){Tidio.open();return;}
      if(window.$crisp){$crisp.push(['do','chat:open']);return;}
      if(window.Intercom){Intercom('show');return;}
      if(window.zE){zE('messenger','open');return;}
      window.location.href='mailto:'+EM;
    });
  }

  // ============ Add to cart ============
  function addToCart(){
    var b=fb(S.bundle);
    var v=fv(b.vk);
    if(!v){alert('Error finding variant. Please contact us.');return;}

    // Required field validation
    if(!S.name || !S.name.trim()){
      alert('Please enter the name or initials you want stamped.');
      var nmEl=root.querySelector('#lt-nm'); if(nmEl) nmEl.focus();
      return;
    }
    if(b.hasPhone && (!S.phone || !S.phone.trim())){
      alert('Please enter the iPhone or Samsung model for the case.');
      var phEl=root.querySelector('#lt-ph'); if(phEl) phEl.focus();
      return;
    }

    var cl=fc(S.color),mn=fm(S.mono);
    var props={
      'Bundle': b.name,
      'Wallet Style': S.wallet==='trifold'?'Trifold':'Bifold',
      'Personalization': S.name.trim()+' | '+mn.n+' | '+(S.gold?'Gold':'Plain')+' | '+cl.n
    };
    if(b.hasPhone){
      props['Phone Model']=S.phone.trim();
    }
    if(S.deadline && S.deadline.trim()){
      props['Gift Deadline']=S.deadline.trim();
    }

    var btn=root.querySelector('#lt-ac');
    if(btn){btn.disabled=true;btn.textContent='Adding\u2026';}

    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1,properties:props})})
    .then(function(r){if(!r.ok)throw new Error('cart_add_failed');return r.json();})
    .then(function(){return fetch('/cart.js').then(function(r){return r.json();});})
    .then(function(c){
      updateCartCount(c.item_count);
      if(btn){
        btn.classList.add('ok');
        btn.disabled=false;
        btn.innerHTML='\u2713 Added \u2014 view cart';
        btn.onclick=function(){window.location.href='/cart';};
      }
      showAddedModal(c.item_count);
    })
    .catch(function(e){
      console.error(e);
      if(btn){btn.disabled=false;btn.textContent='Add to Cart';}
      alert('Something went wrong. Please try again.');
    });
  }

  function updateCartCount(n){
    var selectors=[
      '.cart-count','.cart-link__bubble','.cart-count-bubble',
      '[data-cart-count]','.cart-link span','.icon-cart-count',
      '.site-header__cart-count','.header__cart-count',
      '#CartCount','.cart-counter','.cart__count',
      'a[href="/cart"] .count','.header-cart-count','.cart-link .count'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        el.textContent=n;
        el.style.display='';
        el.classList.remove('hidden','hide');
      });
    });
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{count:n}}));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function showAddedModal(itemCount){
    var ex=document.getElementById('lt-modal');
    if(ex) ex.parentNode.removeChild(ex);

    var modal=document.createElement('div');
    modal.id='lt-modal';
    modal.className='lt-modal';
    modal.innerHTML=
      '<div class="lt-modal-bg"></div>'+
      '<div class="lt-modal-card">'+
        '<div class="lt-modal-icon">\u2713</div>'+
        '<h3 class="lt-modal-h">Added to your cart!</h3>'+
        '<p class="lt-modal-p">Your cart now has <strong>'+itemCount+' item'+(itemCount===1?'':'s')+'</strong>.</p>'+
        '<div class="lt-modal-bs">'+
          '<button type="button" class="lt-modal-b lt-modal-b-2" id="lt-modal-cont">Continue Shopping</button>'+
          '<button type="button" class="lt-modal-b lt-modal-b-1" id="lt-modal-go">Go to Cart \u2192</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(modal);
    requestAnimationFrame(function(){modal.classList.add('on');});

    function close(){
      modal.classList.remove('on');
      setTimeout(function(){if(modal.parentNode)modal.parentNode.removeChild(modal);},250);
    }
    modal.querySelector('.lt-modal-bg').addEventListener('click',close);
    modal.querySelector('#lt-modal-cont').addEventListener('click',close);
    modal.querySelector('#lt-modal-go').addEventListener('click',function(){window.location.href='/cart';});
    function escHandler(e){if(e.key==='Escape'){close();document.removeEventListener('keydown',escHandler);}}
    document.addEventListener('keydown',escHandler);
  }

  R();

  // ============ Swiper gallery ============
  function initSw(){
    if(typeof Swiper==='undefined'){setTimeout(initSw,100);return;}
    if(!document.querySelector('.product-main-slider'))return;
    var th=null;
    if(document.querySelector('.product-thumb-slider')){
      th=new Swiper('.product-thumb-slider',{spaceBetween:10,slidesPerView:4,freeMode:true,watchSlidesProgress:true,loop:true,breakpoints:{640:{slidesPerView:5},768:{slidesPerView:6}}});
    }
    new Swiper('.product-main-slider',{spaceBetween:10,loop:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev'},pagination:{el:'.swiper-pagination',clickable:true},thumbs:th?{swiper:th}:null,zoom:{maxRatio:3,minRatio:1,toggle:true}});
  }
  initSw();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',ltInit);
    window.addEventListener('load',function(){
      var el=document.getElementById('lt-configurator');
      if(el&&!el.querySelector('.lt-bundles')){ltInit();}
    });
  } else {
    ltInit();
  }
})();
